export default __webpack_public_path__ + "static/media/TQL.27002794.png";